"use strict";
/**
 * @file Contains definitions of utility functions that help with retrieving theme informaiton.
 * @copyright Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var $dyn;
(function ($dyn) {
    var ui;
    (function (ui) {
        var theme;
        (function (theme) {
            // A private cache of all collected theme information.
            var themeCache = null;
            /**
             * Collect AX7 theme information on request, use cache if possible.
             * @returns An object containing the theme info (CSS properties) of the current theme.
             */
            function get() {
                if (!themeCache) {
                    themeCache = _collectThemeInfo();
                }
                return themeCache;
            }
            theme.get = get;
            /**
             * Get the less sizing unit as a number
             */
            function getUnitValue(unitName) {
                var themeInfo = $dyn.ui.theme.get();
                if (themeInfo[unitName]) {
                    // strip px off of string
                    var unitValueAsStr = themeInfo[unitName];
                    if (unitValueAsStr.endsWith("px")) {
                        unitValueAsStr = unitValueAsStr.substring(0, unitValueAsStr.length - 2);
                    }
                    return parseInt(unitValueAsStr, 10);
                }
            }
            theme.getUnitValue = getUnitValue;
            /**
             * Flushes the theme info cache.
             */
            function invalidate() {
                themeCache = null;
            }
            theme.invalidate = invalidate;
            /**
             * Get the CSS link ID
             * @param type the css you want (Core, App, FND)
             * @returns The CSS link ID.
             */
            function getCssId(type) {
                return $dyn.densityThemeManager._getCssId(type, $dyn.densityThemeManager._getCurrentDensity(), $dyn.densityThemeManager._getCurrentTheme());
            }
            theme.getCssId = getCssId;
            /**
             * Increase the lightness of a color in the HSL color space by an absolute amount.
             * @param color Any representation (`short hex`, `long hex`, `rgb`, `rgba`) of an HSLA color.
             * @param value The amount to lighten by.
             * @returns The lightened HSLA value.
             */
            function lighten(color, value) {
                color = _any2hsla(color);
                // Split lightness out of the color definition
                var matches = /(.*,\s*)([\d\.%]+)(,.*)$/.exec(color);
                var lightness = parseFloat(matches[2]) + parseFloat(value + "") + "%";
                return matches[1] + lightness + matches[3];
            }
            theme.lighten = lighten;
        })(theme = ui.theme || (ui.theme = {}));
        /**
         * Timings available for motion controlled by javascript.
         * @description Parallel constants are also available for motion controlled by CSS in constants.less.
         */
        // Make sure to keep this in sync with constants.less
        var motionTiming;
        (function (motionTiming) {
            /** Used for fast fade animations with no position change to hide or show content. Purpose is to soften the experience not draw attention */
            motionTiming[motionTiming["quickest"] = 50] = "quickest";
            /** Used when a small object needs to both change opacity and position. */
            motionTiming[motionTiming["quicker"] = 100] = "quicker";
            /** Small to medium sized objects. Typically used for fades and exits. */
            motionTiming[motionTiming["quick"] = 167] = "quick";
            /** Default animation duration used for most movement and resize animations. */
            motionTiming[motionTiming["basic"] = 267] = "basic";
            /** Only used in select hero scenarios that involve movement affecting the entire screen */
            motionTiming[motionTiming["slow"] = 750] = "slow";
        })(motionTiming = ui.motionTiming || (ui.motionTiming = {}));
        // -----------------------------------------------------------------------------
        //  Private methods
        // -----------------------------------------------------------------------------
        /**
         * Collect current theme information, trying to reuse existing DOM elements.
         * @returns An object containing the theme info (CSS properties) of the current theme.
         */
        function _collectThemeInfo() {
            var styles = [
                _retrieveStylesFor("primaryColorsThemeInformation"),
                _retrieveStylesFor("shadesOfGrayThemeInformation"),
                _retrieveStylesFor("textColorsThemeInformation"),
                _retrieveStylesFor("otherColorsPack1ThemeInformation"),
                _retrieveStylesFor("otherColorsPack2ThemeInformation"),
                _retrieveStylesFor("gridColorsThemeInformation"),
                _retrieveStylesFor("appBarColorsThemeInformation"),
                _retrieveStylesFor("chartThemeInformation"),
                _retrieveStylesFor("unitsPack1ThemeInformation"),
                _retrieveStylesFor("unitsPack2ThemeInformation"),
                _retrieveStylesFor("fontsThemeInformation"),
            ];
            var themeInformation = {};
            // tslint:disable-next-line:prefer-for-of
            for (var i = 0; i < styles.length; i++) {
                var style = styles[i];
                for (var key in style) {
                    if (style.hasOwnProperty(key)) {
                        themeInformation[key] = style[key];
                    }
                }
            }
            return themeInformation;
        }
        /**
         * @param className The name of the class to get styles for.
         * @returns A javascript object containing a set of AX7 styles.
         */
        function _retrieveStylesFor(className) {
            var styles = _computeStyles(className);
            // `fontFamily` property contains a JSON with all theme variables.
            var json = styles.fontFamily;
            // Remove surrounding quotes and unescape JSON.
            json = json
                .substring(1, styles.fontFamily.length - 1)
                .replace(/\\'/g, "'")
                .replace(/\\"/g, '"');
            try {
                return JSON.parse(json);
            }
            catch (ex) {
                console.error("Unable to parse AX7 style as a JSON.");
                console.debug(json);
                return {}; // Silent fail
            }
        }
        /**
         * @param className The name of the class to get styles for.
         * @returns Computed style for the provided class name.
         */
        function _computeStyles(className) {
            // Try to find an existing element first.
            var elements = document.getElementsByClassName(className);
            if (elements.length > 0) {
                return getComputedStyle(elements[0]);
            }
            // No element exists, creating a new invisible one.
            var newEl = document.createElement("div");
            newEl.classList.add(className);
            newEl.style.display = "none";
            document.body.appendChild(newEl);
            return getComputedStyle(newEl);
        }
        /**
         * @param color Color in any format (`short hex`, `long hex`, `rgb`, `rgba`)
         * @returns String representing the HSLA value of the color.
         */
        function _any2hsla(color) {
            color = color.toLowerCase();
            if (color.indexOf("hsla(") === 0) {
                return color;
            }
            else if (color.indexOf("hsl(") === 0) {
                return color.replace("hsl(", "hsla(").replace(")", ",1)");
            }
            else {
                return _rgba2hsla(_any2rgba(color));
            }
        }
        /**
         * @param color Color in RGBA format
         * @returns Color in HSLA format.
         */
        function _rgba2hsla(color) {
            var r = color.r / 255;
            var g = color.g / 255;
            var b = color.b / 255;
            var max = Math.max(r, g, b);
            var min = Math.min(r, g, b);
            var d = max - min;
            var u = max + min;
            var h = 0;
            var s = 0;
            var l = u / 2;
            if (d !== 0) {
                s = l < 0.5 ? d / u : d / (2 - u);
                var rr = ((max - r) / 6 + max / 2) / d;
                var gg = ((max - g) / 6 + max / 2) / d;
                var bb = ((max - b) / 6 + max / 2) / d;
                switch (max) {
                    case r:
                        h = bb - gg;
                        break;
                    case g:
                        h = 1 / 3 + (rr - bb);
                        break;
                    case b:
                        h = 2 / 3 + (gg - rr);
                        break;
                }
                if (h < 0) {
                    h += 1;
                }
                if (h > 1) {
                    h -= 1;
                }
                h = Math.round(h * 360);
            }
            s = Math.round(s * 100);
            l = Math.round(l * 100);
            return "hsla({h},{s}%,{l}%,{a})"
                .replace("{h}", h.toString())
                .replace("{s}", s.toString())
                .replace("{l}", l.toString())
                .replace("{a}", color.a.toString());
        }
        /**
         * Convert a color string in any format (`short hex`, `long hex`, `rgb`) to `rgba` values.
         * @param color - Color in any format (`short hex`, `long hex`, `rgb`)
         * @returns Color in RGBA format.
         */
        function _any2rgba(color) {
            color = color.toLowerCase();
            // `hex` format
            if (color.indexOf("#") === 0) {
                // Expand `short hex`, e.g. #ba4 -> #bbaa44
                if (color.length === 4) {
                    color = "#" + color[1] + color[1] + color[2] + color[2] + color[3] + color[3];
                }
                return {
                    r: parseInt(color.substr(1, 2), 16),
                    // tslint:disable-next-line:object-literal-sort-keys
                    g: parseInt(color.substr(3, 2), 16),
                    b: parseInt(color.substr(5, 2), 16),
                    a: 1,
                };
            }
            // `rgb` and `rgba` formats
            var matches = /(\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d\.]+))?/.exec(color);
            return {
                // tslint:disable-next-line:radix
                r: parseInt(matches[1]),
                // tslint:disable-next-line:radix object-literal-sort-keys
                g: parseInt(matches[2]),
                // tslint:disable-next-line:radix
                b: parseInt(matches[3]),
                a: matches[4] != null ? parseFloat(matches[4]) : 1,
            };
        }
    })(ui = $dyn.ui || ($dyn.ui = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=themeInformation.js.map
